import { Injectable } from '@angular/core';
import { HttpService } from '../../rest/http.service';
import { Observable } from 'rxjs';
import { College, ScholarShips } from '../../models/scholarship'
import {VirtueDropdown} from '../../models/dropdown'

const routes = {
    mockscholarship : '/sch_data.json',
    mockfeedbacks : '/feedback.json',
    scholarship : '/scholarship',
    collegeData: '/getCustomerDetails?custid=',
    feedbacks : '/config/getdropdownValue?dropdownName=feedback.types',
    saveFeedback : '/saveFeedback'
};

@Injectable({
  providedIn: 'root'
})
export class ScholarshipService {

  constructor(private httpService : HttpService) { }

  getCollegeData(custid:number) : Observable<College> {
		return this.httpService.get(routes.collegeData+custid);
  }
  
  get() : Observable<ScholarShips> {
		//return this.httpService.getMock(routes.mockscholarship);
		return this.httpService.get(routes.scholarship);
  }

  getFeedbacks() : Observable<VirtueDropdown> {
		return this.httpService.get(routes.feedbacks);
  }

  postFeedback(feedback : any) : Observable<any>  {
    return this.httpService.post(routes.saveFeedback, feedback);
  }
}
